import { render, staticRenderFns } from "./InterestFollowUpUpdate.vue?vue&type=template&id=28805028&"
import script from "./InterestFollowUpUpdate.vue?vue&type=script&lang=js&"
export * from "./InterestFollowUpUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports